import { PricingInterval } from 'types/subscription.types';

export const paymentIntervalOptions: Array<{
  label: string;
  value: PricingInterval;
}> = [
  { label: 'Monthly', value: 'month' },
  { label: 'Yearly', value: 'year' },
];

export const DEFAULT_CURRENCY = 'usd';
